/**
 * @description 埋点相关
 */

export enum ActivitySourceEnum {
  homeBanner = 'homeBanner',
  activityList = 'activityList',
  activityTab = 'activityTab',
  bottomTab = 'bottomTab',
  operation = 'operation',
  redirectAfterClaim = 'redirectAfterClaim',
  inbox = 'inbox',
  rewardsCenter = 'rewardsCenter',
  rewardsPopup = 'rewardsPopup',
  banner = 'banner',
}

export const ACTIVITY_SOURCE_MAP = {
  [ActivitySourceEnum.activityTab]: 'Activity Center Tab',
  [ActivitySourceEnum.activityList]: 'Activity Center List',
  [ActivitySourceEnum.homeBanner]: 'Home banner',
  [ActivitySourceEnum.bottomTab]: 'Bottom Tab',
  [ActivitySourceEnum.operation]: 'Operation',
  [ActivitySourceEnum.redirectAfterClaim]: 'Redirect After Claim',
  [ActivitySourceEnum.inbox]: 'In Box',
  [ActivitySourceEnum.rewardsCenter]: 'Rewards Center',
  [ActivitySourceEnum.rewardsPopup]: 'Rewards Popup',
  [ActivitySourceEnum.banner]: 'Banner',
};

// 入口来源
export enum LOGIN_SOURCE_MAP {
  ColorBallRace = 'ColorBall Race',
  Top = 'Top',
  Home = 'Home',
  DepositSpin = 'Deposit & Spin',
  Turntable = 'Turntable',
  Referral = 'Referral',
  RewardsCenter = 'Rewards Center',
  RewardsPopup = 'Rewards Popup',
  VIP = 'VIP',
  WelcomeBonus = 'Welcome Bonus',
  GameDetail = 'game detail',
  Gullak = 'Gullak',
  Rummy = 'Rummy',
  Fantasy = 'Fantasy',
}